<template>
  <div class="relative transform flex flex-col bg-white text-left shadow-xl w-full">
    <slot />
  </div>
</template>
